/* eslint-disable no-unused-vars */
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Box,
  Button,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SortableElement, SortableContainer } from 'react-sortable-hoc';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import TableLoader from '../TableLoader';
import PrivateWrapper from '../../layout/Private';
import listingStyle from '../../theme/styles/pages/Listing';
import { getChannelAllVideos, updateProgramOrder } from '../../services/Channels';
import SnackbarMessage from '../SnackbarMessage';
import RoutePaths from '../../config/Routes';
import arrayMoveImmutable from '../../utils/ArrayMove';

const useStyles = makeStyles(listingStyle);

// const useQuery = () => new URLSearchParams(useLocation().search);

const SortableRow = SortableElement(({ row }) => {
  const classes = useStyles();

  return (
    <TableRow className={classes.draggableTableRow}>
      <TableCell width="100%" className={classes.draggableTableCell}>
        <DragHandleIcon />
        <span>{row.title}</span>
      </TableCell>
    </TableRow>
  );
});

const SortableRowList = SortableContainer(({ rows }) => {
  const classes = useStyles();

  return (
    <ul className={classes.sortUl}>
      {rows.map((row, index) => (
        <SortableRow row={row} index={index} sortIndex={index} />
      ))}
    </ul>
  );
});

const ChannelProgramOrder = ({ match }) => {
  const pageName = 'Manage Program Order';
  const classes = useStyles();
  const history = useHistory();
  // const query = useQuery();
  // const searchText = query.get('search');
  // const orderBy = query.get('orderby');
  // const sortby = query.get('sortby');
  // const page = query.get('page');
  const { id } = match.params;

  const [rows, setRows] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [reloadRows, setReloadRows] = useState(false);
  const [saveData, setSaveData] = useState(false);

  const [snackbarMeesage, setSnackbarMeesage] = useState({
    show: false,
    type: '',
    message: '',
  });

  // const [heading, setHeading] = useState('');

  const saveProgramOrder = async () => {
    setSaveData(true);
    setSnackbarMeesage({
      message: '',
      type: '',
      show: false,
    });

    try {
      const rowsCpy = [...rows];
      rowsCpy.forEach((_, idx) => {
        rowsCpy[idx].displayOrder = idx;
      });

      await updateProgramOrder(id, rowsCpy);

      setSnackbarMeesage({
        message: 'Programs order changed successfully.',
        type: 'success',
        show: true,
      });
      setSaveData(false);
      setReloadRows(!reloadRows);
    } catch (error) {
      setSnackbarMeesage({
        message: 'Something went wrong. Please Refresh the page and retry.',
        type: 'error',
        show: true,
      });
      setSaveData(false);
    }
  };
  useEffect(() => {
    // viewById(id)
    //   .then((res) => {
    //     setHeading(res.data.name);
    //   })
    //   .catch(() => {
    //     setHeading('');
    //   });
    getChannelAllVideos(id)
      .then((res) => {
        setRows(res.data.rows);
        setDataLoaded(true);
      })
      .catch(() => {
        setSnackbarMeesage({
          ...snackbarMeesage,
          message: 'Error in loading the data.',
          type: 'error',
          show: true,
        });
        setRows([]);
        setDataLoaded(true);
      });
  }, []);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setRows(arrayMoveImmutable(rows, oldIndex, newIndex));
  };

  const handleBack = () => {
    history.push(`${RoutePaths.MY_CHANNEL}`);
  };

  return (
    <PrivateWrapper pageName={pageName}>
      <div>
        <Box mt={2}>
          <div className={classes.filterToolbar}>
            <div className={classes.filterLeft}>
              {/* <IconButton size="small" onClick={handleBack}>
                <ArrowBack />
              </IconButton> */}
              {/* <Typography variant="h5" style={{ marginLeft: 10 }}>
                {heading} - Manage Program Order
              </Typography> */}
            </div>
            <div className={classes.filterRight}>
              <Button
                variant="contained"
                color="primary"
                className={classes.addNewBtn}
                onClick={saveProgramOrder}
                disabled={saveData}
              >
                {saveData ? 'Saving...' : 'Save Order'}
              </Button>
              <Button
                variant="contained"
                className={classes.addNewBtn}
                onClick={handleBack}
                disabled={saveData}
              >
                Back
              </Button>
            </div>
          </div>
          <Divider />
        </Box>

        <TableContainer>
          <Table className={classes.tableData} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell width="100%">Video Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!dataLoaded && <TableLoader cols={1} />}
              {dataLoaded && rows.length === 0 && (
                <TableCell
                  align="center"
                  size="medium"
                  colSpan={1}
                  className={classes.noRecordFoundText}
                >
                  No records found
                </TableCell>
              )}
              {dataLoaded && <SortableRowList rows={rows} lockAxis="y" onSortEnd={onSortEnd} />}
            </TableBody>
          </Table>
        </TableContainer>

        {snackbarMeesage.show && <SnackbarMessage {...snackbarMeesage} />}
      </div>
    </PrivateWrapper>
  );
};
export default ChannelProgramOrder;

ChannelProgramOrder.propTypes = {
  match: PropTypes.objectOf().isRequired,
};
